<template>
  <div class="wrap">
    <v-icon name="regular/surprise" class="icon" scale="2" />

    <div v-if="status === 'ALL'">
      <p class="label">
        No campaigns found
      </p>

      <p class="label mb-6">
        Get started by selecting a template from the store&hellip;
      </p>

      <Button class="alt sm inline-block" to="/templates"
        ><v-icon
          slot="icon-start"
          name="palette"
          scale=".8"
          class="inline-block mr-1"
        />
        Browse Templates</Button
      >
    </div>

    <p v-else class="label">
      No campaigns found for selected filter
    </p>
  </div>
</template>

<script>
export default {
  name: "CampaignListEmpty",
  props: {
    status: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.wrap {
  @apply text-center;
}

.icon {
  @apply text-grey-lighter mb-2;
}

.label {
  @apply mb-2 text-grey text-sm;

  @screen sm {
    @apply text-base;
  }
}
</style>
